import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from 'src/app/layout/pages/page-not-found/page-not-found.component';

import { ConsumersComponent } from './consumers.component';

import { AllConsumersComponent } from './all-consumers/all-consumers.component';
import { EditConsumerComponent } from './manage-consumers/edit-consumer/edit-consumer.component';
import { ManageConsumersComponent } from './manage-consumers/manage-consumers.component';
import { PromocodeHistoryComponent } from './manage-consumers/promocode-history/promocode-history.component';
import{LoyaltyPointHistoryComponent} from './manage-consumers/loyalty-point-history/loyalty-point-history.component'
import { ConsumerLogsComponent } from './manage-consumers/consumer-logs/consumer-logs.component';
// import { PaymentHistoryComponent } from './manage-consumers/payment-history/payment-history.component';
import { CommentsComponent } from './manage-consumers/comments/comments.component';
import { EditcommentComponent } from './manage-consumers/comments/editcomment/editcomment.component';
import { CreatecommentsComponent } from './manage-consumers/comments/createcomments/createcomments.component';
import { TransactionHistoryComponent } from './manage-consumers/transaction-history/transaction-history.component';
import { FeeConfigComponent } from './fee-config/fee-config.component';
import { AllFeeComponent } from './fee-config/all-fee/all-fee.component';
import { ConfigHistoryComponent } from './fee-config/config-history/config-history.component';
import { ConsumerBannerComponent } from './consumer-banner/consumer-banner.component';
import { ManageConsumerBannerComponent } from './consumer-banner/manage-consumer-banner/manage-consumer-banner.component';
import { EditConsumerBannerComponent } from './consumer-banner/edit-consumer-banner/edit-consumer-banner.component';
import { AddConsumerBannerComponent } from './consumer-banner/add-consumer-banner/add-consumer-banner.component';
import { EditConsumerBannerSmartComponent } from './consumer-banner/edit-consumer-banner/edit-consumer-banner-smart.component';
import { AddFeeComponent } from './fee-config/add-fee/add-fee.component';
import { EditFeeComponent } from './fee-config/edit-fee/edit-fee.component';
import { PaymentReportComponent } from './manage-consumers/payment-report/payment-report.component';
export const consumersRoutes: Routes = [
  {
    path: 'all-consumers', component: AllConsumersComponent,
  },
  {
    path: 'fee-config',component:FeeConfigComponent,
    children:[
      {
        path:'all-fee', component: AllFeeComponent,
      },
      {
        path: "manage-fee/:id",
        component: EditFeeComponent,
      },
      {
        path: "add-fee",
        component: AddFeeComponent,
      },
      {
        path:'config-history/:id',component:ConfigHistoryComponent
      },
      {
        path: '',
        redirectTo: 'all-fee',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'consumer-banner',component:ConsumerBannerComponent,
    children: [
      {
        path: "manage-banner",
        component: ManageConsumerBannerComponent,
      },
      {
        path: "edit-banner/:id",
        component: EditConsumerBannerSmartComponent,
      },
      {
        path: "add-banner",
        component: AddConsumerBannerComponent,
      },
       {
        path: '',
        redirectTo: 'manage-banner',
        pathMatch: 'full'
      }
    ],
  },
  {
    path: 'manage-consumers/:userId', component: ManageConsumersComponent,
    children: [
      {
        path: 'edit-consumer/:userId', component: EditConsumerComponent,
      },
      {
        path: 'transaction/:userId', component: TransactionHistoryComponent,
      },
      {
        path: 'loyalty-point-history/:userId', component: LoyaltyPointHistoryComponent,
      },
      {
        path: 'promocode-history/:userId', component: PromocodeHistoryComponent,
      },
      {
        path: 'consumer-logs/:userId', component: ConsumerLogsComponent,
      },
      {
        path: 'payment-history/:userId', component: PaymentReportComponent,
      },
      {
        path: 'comments/:userId', component: CommentsComponent,
      },
      {
        path: 'comments/:userId/edit/:consumerCommentId', component: EditcommentComponent,
      },
      {
        path: 'comments/:userId/create', component: CreatecommentsComponent,
      },
      {
        path: 'comments/:userId/create/:userId', component: CreatecommentsComponent,
      },
    ]
  },
  {
    path: '', redirectTo: 'all-consumers', pathMatch: 'full'
  },
  {
    path: '**', component: PageNotFoundComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(consumersRoutes)],
  exports: [RouterModule]
})
export class ConsumersRoutingModule { }
